import { Component, inject, computed } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { Sidebar as SidebarService, Toaster } from '@shared/services';
import { Auth } from '@core/services';
import { UserRole } from '@core/interfaces/role.interface';
import { UserPermission } from '@core/interfaces/userPermission.interface';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss'
})
export class Sidebar {
  protected readonly UserPermission = UserPermission;
  private router = inject(Router);
  private authService = inject(Auth);
  sidebarService = inject(SidebarService);
  private toasterService = inject(Toaster);

  user = computed(() => this.authService.user || {});
  isAdmin = computed(() => this.user().role?.name === UserRole.ADMIN);
  esimPermissions = computed(() => this.user().userPermission?.esimPermissions || {});

  logout() {
    this.sidebarService.logout().subscribe({
      next: () => {
        this.authService.user = null;
        this.authService.token = '';
        localStorage.clear();
        this.router.navigate(['/login']);
      },
      error: (error) => {
        this.toasterService.errorAlert(error.error?.message || 'Failed to logout');
      }
    });
  }
}
